import React from "react"
import * as styles from "./styleModal.module.scss"
import Modal from "../modal"
import classnames from "@src/utils/classnames"
import Button from "../button"

const StyleModal = React.memo(
  ({ isOpen, close, children, className, ...restProps }) => {
    return (
      <Modal
        isOpen={isOpen}
        className={classnames(styles.popBox_base, className)}
        overlayClassName={classnames(styles.popBox_overlay)}
        shouldCloseOnOverlayClick
        onRequestClose={close}
        {...restProps}
      >
        <div className={classnames("e_popBox", styles.popBox)}>
          <div className={styles.closeBtnContainer}>
            <Button type="blue" icon="close" onClick={close}>
              关闭
            </Button>
          </div>
          {children}
        </div>
      </Modal>
    )
  }
)

StyleModal.displayName = "StyleModal"
export default StyleModal
